module.exports = __webpack_public_path__ + "static/bible.5ea54a66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bible.jpg
// module id = 399
// module chunks = 104101334113578